import { BUILDING_LOCKED_TOOLTIP_POSITION } from '@/map-phaser-new/constants'
import type { BuildingConfigInterface } from '@/map-phaser-new/interfaces'

export const premiumConfig: BuildingConfigInterface = {
  textureKey: 'buildings',
  frameKey: 'premium',
  routeConfig: {
    routeName: 'PremiumGems',
    soundName: 'click-map-artefact',
    isRouteParamIdNeeded: false,
    openBuildingEndpoint: 'meta/buildings/open/premium',
  },
  positionX: 1024,
  positionY: 1305,
  depth: 4,
  originX: 0,
  keyForTranslateTitle: 'map.premiumName',
  buildingTitleConfig: {
    positionX: 1085,
    positionY: 1540,
    depth: 7,
    textConfig: {
      originX: 0.5,
      fontName: 'Roboto Condensed',
      fontSize: '24px',
      fontWeight: 'normal',
      fontStyle: 'italic',
      fontColor: '#fff',
    },
    backgroundImageConfig: {
      textureName: 'common',
      frameNameRightSide: 'right_side',
      frameNameRightSideLocked: 'right_side_locked',
      originX: 0.5,
      widthCorrection: 100,
      heightCorrection: 10,
    },
  },
  outlineConfig: {
    framePostFix: '_outline',
    depth: 6,
    originX: 0,
    positionByLevel: {
      '1': { positionX: 1024, positionY: 1305 },
    },
    textureKey: 'buildingsOutlines',
  },
  inputConfig: {
    useHandCursor: true,
    pixelPerfect: true,
  },
  buildingLockedConfig: {
    textureKey: 'lockedBuildings',
    framePostfix: '_locked',
    lockImageTextureKey: 'lock',
    positionX: 1156,
    positionY: 1432,
    lockImageDepth: 6,
    depth: 5,
    tooltipConfig: {
      tooltipPosition: BUILDING_LOCKED_TOOLTIP_POSITION.Top,
      tooltipTextureHeight: '213px',
      tooltipTextureWidth: '444px',
      depth: 10,
      titleConfig: {
        originX: 0.5,
        fontSize: '30px',
        fontName: 'Roboto Condensed',
        fontWeight: 'normal',
        fontStyle: 'italic',
        fontColor: '#fff',
      },
      subtitleConfig: {
        originX: 0.5,
        originY: 0.5,
        fontName: 'Roboto Condensed',
        fontSize: '24px',
        fontWeight: 'normal',
        fontStyle: 'italic',
        fontColor: '#fff',
        tooltipSubtitleTranslateKey: 'common.comingSoon',
      },
      tooltipHideDelay: 2000,
      tooltipLeftTextureName: 'building_tooltip_left',
      tooltipRightTextureName: 'building_tooltip_right',
      tooltipTopTextureName: 'building_tooltip_top',
    },
  },

  buildingExclamationNotificationConfig: {
    correctionPositionX: 0,
    correctionPositionY: 320,
  },
}
